import React, { useState } from "react";
import { Button } from "./Button";

/**
 * Компонент для запроса геопозиции пользователя
 * Показывает модальное окно с объяснением и кнопками разрешить/отклонить
 */
function GeolocationRequest({ onComplete, onSkip }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const requestGeolocation = async () => {
    setIsLoading(true);
    setError(null);

    if (!navigator.geolocation) {
      setError("Ваш браузер не поддерживает геолокацию");
      setIsLoading(false);
      return;
    }

    const geoOptions = {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
    };

    
    

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, geoOptions);
      });


      const coordinates = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy,
      };

      console.log("📍 Геопозиция получена:", coordinates);
      onComplete(coordinates);
    } catch (err) {
      console.error("❌ Ошибка получения геопозиции:", err);

      let errorMessage = "Не удалось определить местоположение";

      switch (err.code) {
        case err.PERMISSION_DENIED:
          errorMessage =
            "Доступ к геолокации запрещен. Вы можете изменить это в настройках.";
          break;
        case err.POSITION_UNAVAILABLE:
          errorMessage = "Информация о местоположении недоступна";
          break;
        case err.TIMEOUT:
          errorMessage = "Время ожидания истекло. Попробуйте еще раз.";
          break;
        default:
          errorMessage = "Произошла неизвестная ошибка";
      }

      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm">
      <div className="w-[343px] bg-[#043939] rounded-[24px] p-6 flex flex-col items-center">
        {/* Иконка геолокации */}
        <div className="w-[80px] h-[80px] bg-[#a1f69e]/20 rounded-full flex items-center justify-center mb-6">
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
              fill="#a1f69e"
            />
          </svg>
        </div>

        {/* Заголовок */}
        <h2 className="text-white text-[22px] font-semibold text-center mb-3">
          Разрешить доступ к геопозиции?
        </h2>

        {/* Описание */}
        <p className="text-gray-300 text-[14px] text-center mb-6 leading-relaxed">
          Это поможет нам показывать вам анкеты людей, которые находятся рядом с
          вами
        </p>

        {/* Ошибка */}
        {error && (
          <div className="w-full bg-red-500/20 border border-red-500/50 rounded-lg p-3 mb-4">
            <p className="text-red-300 text-[13px] text-center">{error}</p>
          </div>
        )}

        {/* Кнопки */}
        <div className="w-full flex flex-col gap-3">
          <Button
            onClick={requestGeolocation}
            disabled={isLoading}
            className="w-full"
          >
            {isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <svg
                  className="animate-spin h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Определяем...
              </span>
            ) : (
              "Разрешить"
            )}
          </Button>

          <button
            onClick={onSkip}
            className="w-full py-3 text-gray-400 text-[15px] hover:text-white transition-colors"
            disabled={isLoading}
          >
            Пропустить
          </button>
        </div>

        {/* Подсказка */}
        <p className="text-gray-500 text-[12px] text-center mt-4">
          Вы всегда можете изменить это в настройках профиля
        </p>
      </div>
    </div>
  );
}

export default GeolocationRequest;
